import { connect } from 'react-redux';

import { selectSpaceInfo } from '../../app/selectors/ContentSelectors';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ChannelTypes } from '../types/ChannelTypes';
import { Channel, ChannelOwnProps, ChannelProps } from './Channel';

export const ConnectedRecentsChannel = connect((state: AppState, props: ChannelOwnProps) => {
  const siteUrls = siteUrlsSelector(state);

  let list: IContentInfo[] = [];
  state.home.recents.items.forEach((contentId: string) => {
    list.push(state.home.contentById[contentId]);
  });

  const recentChannelProps: ChannelProps = {
    channelType: ChannelTypes.recents,
    title: Messages.home_recentsTitle(),
    seeAllUrl: siteUrls.recentsUrl(),
    seeAllAltText: Messages.home_recents_alt_seeAll(),
    list,
    isFetching: state.home.recents.isFetching,
    numRows: 2,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(state)
  };
  return recentChannelProps;
})(Channel);
